import { z } from "zod";
import {
    CloseTemplateCreateSchema,
    CloseTemplateBasis,
} from "@common/schemas/close-template.schema";

export type CloseTemplateFormValues = z.infer<typeof CloseTemplateCreateSchema>;

export const basisOptions: Array<{
    value: CloseTemplateBasis;
    label: string;
}> = [
    { value: CloseTemplateBasis.ACCRUAL, label: "Accrual" },
    {
        value: CloseTemplateBasis.MODIFIED_CASH_LEDGER,
        label: "Cash",
    },
];
